import { Link } from "react-router-dom";
import { useReveal } from "@/lib/reveal";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import ConsentScripts from "@/components/ConsentScripts";
import { GlobalCommandBar } from "@/components/CommandBar";
import AssistantWidget from "@/components/AssistantWidget";

export const Layout = ({ children, testId = "page" }) => {
  const scope = useReveal();
  return (
    <div ref={scope} data-testid={testId} className="bg-white min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-[72px]">{children}</main>
      <Footer />
      <CookieConsent />
      <ConsentScripts />
      <GlobalCommandBar />
      <AssistantWidget />
    </div>
  );
};

export const Breadcrumb = ({ items }) => (
  <nav className="text-[12.5px] text-[color:var(--gv-ink)]/55 flex items-center gap-1.5">
    {items.map((it, i) => (
      <span key={i} className="flex items-center gap-1.5">
        {i > 0 && <span className="text-[color:var(--gv-ink)]/25">/</span>}
        {it.to ? (
          <Link to={it.to} className="hover:text-[color:var(--gv-pink)]">{it.label}</Link>
        ) : (
          <span className="text-[color:var(--gv-ink)]/75">{it.label}</span>
        )}
      </span>
    ))}
  </nav>
);

export default Layout;
